<template>
  <section class="max-w-md mx-auto">
    <div class="select-container max-w-xs mx-auto mt-6">
      <select v-model="status">
        <option
          v-for="option in options"
          :key="option"
          :value="option.toLowerCase()"
          v-text="option"
        />
      </select>
    </div>
    <div class="my-6 flex justify-center">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-primary btn"
        @click="nextTab"
        v-text="'Next'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'

export default {
  name: 'ActivateDeactivate',
  mixins: [TabNavigation],
  data() {
    return {
      options: [
        'Activate',
        'Deactivate',
      ],
      status: 'activate',
    }
  },
  watch: {
    status() {
      this.$emit('statusSelected', this.status)
    },
  },
}
</script>
